import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { RegisterReviewPostRequest } from '@/domain/entities/reviewPost/registerReviewPostRequest'
import { ReviewPostRepository } from '@/domain/repositories/reviewPost/reviewPostRepository'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { ReviewEntryListDecoder } from '@/infrastructure/decoders/review/review'

export class ReviewPostRepositoryImpl implements ReviewPostRepository {
  constructor(private clients: ApiClients) {}

  async getByProblemIdOpenEntries(problemId: string): Promise<ReviewEntry[]> {
    const path = `review/entries/problems/${problemId}`
    const data = await this.clients.reviewClient.fetchAndDecode(ReviewEntryListDecoder, path)
    return data
  }

  async postReview(entryId: string, message: string, reviewerId: string): Promise<void> {
    const post: RegisterReviewPostRequest = {
      entryId: entryId,
      message: message,
      prompt: '',
      reviewerId: reviewerId,
      revisedCode: ''
    }
    const path = `review_proxy/review`
    await this.clients.aojClient.fetch(path, {
      method: 'POST',
      body: JSON.stringify(post)
    })
  }
}
